module.exports = __webpack_public_path__ + "assets/scotch-and-soda-logo-horizontal.d77f890e.svg";